<template>
  <div>
    <!-- 区域 -->
    <div
      class="key"
      id="key"
      ref="wordcloud"
      v-loading="loading"
      element-loading-background="rgba(16,164,178, 0.2)"
    ></div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import "echarts-wordcloud/dist/echarts-wordcloud";
import "echarts-wordcloud/dist/echarts-wordcloud.min";
export default {
  data() {
    return {
      loading: false,
      key: [],
    };
  },
  props: ["analyze"],
  components: {},
  computed: {},
  beforeMount() {},
  mounted() {
    this.Key();
  },
  methods: {
    async Key() {
      this.loading = true;
      let data = { content: this.analyze };
      const { data: res } = await this.$http.post("/nlpir/keyExtract", data);
      this.loading = false;
      JSON.stringify(res).replace(/value/g, "Weight");
      JSON.stringify(res).replace(/name/g, "Word");
      var val = [];
      var name = [];
      var newDate = [];
      for (let i = 0; i < res.length; i++) {
        val.push(res[i].weight);
        name.push(res[i].word);
        var obj = {
          value: res[i].weight,

          name: res[i].word,
        };
        newDate.push(obj);
      }
      // console.log(newDate);
      this.key = newDate;
      // 启动echarts
      this.echarts();
    },
    echarts() {
      let antistop_echart = echarts.init(this.$refs.wordcloud);
      antistop_echart.setOption({
        series: [
          {
            type: "wordCloud",
            //用来调整词之间的距离
            gridSize: 10,
            //用来调整字的大小范围
            // Text size range which the value in data will be mapped to.
            // Default to have minimum 12px and maximum 60px size.
            sizeRange: [14, 60],
            // Text rotation range and step in degree. Text will be rotated randomly in range [-90,                                                                             90] by rotationStep 45
            //用来调整词的旋转方向，，[0,0]--代表着没有角度，也就是词为水平方向，需要设置角度参考注释内容
            // rotationRange: [-45, 0, 45, 90],
            // rotationRange: [ 0,90],
            rotationRange: [0, 0],
            //随机生成字体颜色
            // maskImage: maskImage,
            textStyle: {
              normal: {
                color: function () {
                  return (
                    "rgb(" +
                    Math.round(Math.random() * 255) +
                    ", " +
                    Math.round(Math.random() * 255) +
                    ", " +
                    Math.round(Math.random() * 255) +
                    ")"
                  );
                },
              },
              emphasis: {
                shadowBlur: 10,
                shadowColor: "#2ac",
              },
            },
            //数据
            data: this.key,
          },
        ],
      });
      window.onresize = function () {
        antistop_echart.resize();
      };
    },
  },
  watch: {},
};
</script>
<style scoped>
.key {
  width: 100%;
  height: 359px;
  color: #fff;
  box-sizing: border-box;
  overflow: auto;
}
</style>
